module.exports = __webpack_public_path__ + "static/media/bot-builder-poster.481fe97b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/bot-builder-poster.jpg
// module id = 414
// module chunks = 0